export default __webpack_public_path__ + "dist/imgs/background-square-one.png";